import { proxy } from "valtio";
import { TUser } from "@/types";
import { setFromStorage, getFromStorage, deleteFromStorage } from "@/utils/storage";
import { TOKEN, USER } from "@/http";



export type TAuthStore = {
    getUserEmail: () => string | null
    getUser: () => TUser | null,
    setUser: (user: TUser) => void
    getPermissions: () => string[]
    setToken: (token: string) => void
    getToken: () => string | null
    logout: () => void
}

export const authStore = proxy<TAuthStore>({
    getUserEmail: (): string | null => {
        const data = getFromStorage(USER);

        if(data && typeof data === "string") return data
        return null
    },

    getToken(): string | null {
        const data = getFromStorage<string>(TOKEN);

        if(data && typeof data === "string") return data
        return null
    },

    getUser(): TUser | null {
        const data = getFromStorage<TUser>(USER);

        if(data) return data
        return null
    },

    getPermissions(): string[] {
        const user = authStore.getUser();
        if(user) {
            return user.role?.permissions?.map((el) => (el.name)) ?? []
        }
        return []
    },

    setUser: (user: TUser) => {
        setFromStorage(USER, user);
    },

    setToken: (token: string) => {
        setFromStorage(TOKEN, token)
    },

    logout: () => {
        deleteFromStorage(TOKEN);
        deleteFromStorage(USER);
    }
});